module.exports = __webpack_public_path__ + "img/img-76.26b4e54b.png";